import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../common/icons/AKKOPlan-Icon.svg'


_pushScopeId("data-v-189e62d0")
const _hoisted_1 = { class: "form-container rounded p-4" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Select Your Plan", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = { class: "d-flex flex-column align-items-center justify-content-around" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  height: "70",
  width: "70",
  alt: "Phone Plan",
  src: _imports_0
}, null, -1)
const _hoisted_8 = { class: "mb-0 mt-1 nowrap cera-med al-center-mobile" }
const _hoisted_9 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_10 = { class: "d-flex flex-row mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "\n              d-flex\n              align-items-center\n              justify-content-center\n              select-label\n              fs-7\n              p-2\n            ",
  style: {"min-width":"56px"}
}, " Make ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: "",
  disabled: ""
}, "Select Make", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "d-flex flex-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "\n              d-flex\n              align-items-center\n              justify-content-center\n              select-label\n              fs-7\n              p-2\n            " }, " Model ", -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: "",
  disabled: ""
}, "Select Model", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = (e) => _ctx.$emit('productRemoved')),
        class: "\n          px-25\n          py-1\n          btn btn-primary\n          inter\n          btn-mobile\n          w-100-mobile\n          fw-600\n          ml-auto\n          d-flex\n          align-items-center\n          fs-65\n        "
      }, [
        _createVNode(_component_CloseIcon, { class: "pointer close-icon" }),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.productGroupDisplayName), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("select", {
            class: "form-select p-2 fs-7 select",
            onChange: _cache[1] || (_cache[1] = (e) => _ctx.makeSelected(e.target.value))
          }, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devicesMakes, (make) => {
              return (_openBlock(), _createElementBlock("option", {
                key: make,
                value: make
              }, _toDisplayString(make), 9, _hoisted_13))
            }), 128))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("select", {
            disabled: !_ctx.selectedMake,
            class: "form-select p-2 fs-7 select",
            onChange: _cache[2] || (_cache[2] = (e) => _ctx.modelSelected(e.target.value))
          }, [
            _hoisted_17,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceModels, (model) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "black",
                key: model
              }, _toDisplayString(model), 1))
            }), 128))
          ], 40, _hoisted_16)
        ])
      ])
    ])
  ]))
}